import { addCardButtonStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton";
import { cardListStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList";
import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import { editCardModalStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

addCardButtonStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        nav {
            span {
                color: #FFFFFF !important;
            }
            ul {
                background: #FFFFFF !important;
            }
        }
    `,
}

addCardButtonStyles.addCardButton = { variant: "primary" }

editCardModalStyles. cancelButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                css`
                    margin-right: 20px;
                `,
                css`
                    margin-right: 20px;
                `,
                css`
                    margin-right: 20px;
                `,
            ])}
    `,
}

editCardModalStyles.saveButton = {
    mergeCss:true,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
    `,
}

cardListStyles.useAsDefaultButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        width: 100%;
        padding: 0 8px;
    `,
}

cardListStyles.leftColumnGridItem = {
    width: [6, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
}

cardListStyles.centerColumnGridItem = {
    width: [6, 6, 4, 4, 4],
    css: css`
        flex-direction: column;
        display:none;
    `,
}

cardListStyles.rightColumnGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        align-items: center;
    `,
}

defaultCardStyles.leftColumnGridItem = {
    width: [6, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
}

defaultCardStyles.centerColumnGridItem = {
    width: [6, 6, 4, 4, 4],
    css: css`
        flex-direction: column;
        display:none;
    `,
}

defaultCardStyles.rightColumnGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        align-items: center;
    `,
}